import { useState } from "react";
import { useUpdateEffect } from "react-use";
import useTransition from "react-transition-state";
import Loader from "../common/Loader";
import MyInfoModal from "./MyInfoModal";
import { useQueryClient } from "react-query";
import { getAuth } from "../../api";
import { useSetRecoilState } from "recoil";
import { signItem } from "../../states/atoms/signState";
import { useNavigate } from "react-router-dom";

const MyInfoCard = ({ loading, name, school, ...rest }) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const setSignInfo = useSetRecoilState(signItem);
  const [infoModal, setInfoModal] = useState({ open: false, data: null });
  const [{ status }, toggle] = useTransition({
    timeout: 500,
    initialEntered: true,
    preEnter: true,
  });
  const getAuthResult = async (token) => {
    if (!token) {
      setSignInfo({ result: false, info: null, error: null });
      return navigate("/signout");
    }
    const res = await queryClient.fetchQuery(["auth/check"], {
      queryFn: () => getAuth(token),
      staleTime: 0,
    });
    const { result, error, data: info } = res;
    if (result) {
      setSignInfo({ result, info, error: null });
    } else {
      setSignInfo({ result: false, info: null, error });
      navigate("/signout");
    }
    queryClient.invalidateQueries("auth/check");
  };

  const handleInfoModalClose = () => {
    getAuthResult(localStorage.getItem("token"));
    setInfoModal({ open: false, data: null });
  };
  const handleInfoModal = () => {
    setInfoModal({
      open: true,
      data: { ...rest, name, school },
      onClose: handleInfoModalClose,
    });
  };

  useUpdateEffect(() => {
    if (!loading) {
      toggle();
    }
  }, [loading]);

  return (
    <div className="card bg-white shadow col-span-6 md:col-span-2">
      <div className="card-body">
        <h2 className="card-title">내 정보</h2>
        {loading && (
          <div className="flex flex-row justify-center h-full">
            <Loader className={`basic-transition ${status}`} />
          </div>
        )}
        {!loading && (
          <>
            <div className="flex flex-row justify-center md:flex-col items-center gap-2">
              <div className="avatar placeholder">
                <div className=" bg-accent-focus text-accent-content rounded-full w-24">
                  <span className="text-2xl">{name}</span>
                </div>
              </div>
              <div className="flex flex-col">
                <div className="inline-flex items-center gap-2">
                  <p className="label text-sm font-bold flex-none">이름</p>
                  <p className="text-xl">{name}</p>
                </div>
                <div className="inline-flex items-center gap-2">
                  <p className="label text-sm font-bold flex-none">학교</p>
                  <p className="text-xl">{school.name}</p>
                </div>
              </div>
            </div>
            <div className="card-actions justify-end mt-4">
              <button
                className="btn btn-primary btn-sm w-full"
                onClick={handleInfoModal}
              >
                내 정보 확인
              </button>
            </div>
          </>
        )}
        <MyInfoModal {...{ ...infoModal }} />
      </div>
    </div>
  );
};

export default MyInfoCard;
